
const $disclaimer = $('.js-cookies');

if (getCookie('cookiesAccepted')) {
    $disclaimer.addClass('_hidden');
} else {
    $disclaimer.removeClass('_hidden');
}

$('.js-cookies-agree').on('click', function() {
    $disclaimer.addClass('_hidden');
    const oneYearInSeconds = 60 * 60 * 24 * 365;
    setCookie('cookiesAccepted', '1', {'max-age': oneYearInSeconds, path: '/' });
});

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}


// WEBPACK FOOTER //
// ./_src/js/Cookies.js